import { TFunction } from 'i18next'
import TestdataSoapRestService from './TestdataSoapRestService'
import { saveAs } from 'file-saver'

class TestdataSoapService {
  async getAllWebServicepolicies(setWebServicePolicies?: React.Dispatch<any>) {
    if (setWebServicePolicies) {
      const webServicePolicies = await TestdataSoapRestService.getAllWebServicePolicies()
      setWebServicePolicies(webServicePolicies)
    } else {
      return TestdataSoapRestService.getAllWebServicePolicies()
    }
  }

  async createPolicy(webServicePolicy: any, t: TFunction, setWebServicePolicies?: React.Dispatch<any>) {
    try {
      const createdPolicy = await TestdataSoapRestService.createWebServicePolicy(webServicePolicy)
      if (setWebServicePolicies) {
        const webServicePolicies = await TestdataSoapRestService.getAllWebServicePolicies()
        setWebServicePolicies(webServicePolicies)
      }
      return t('testdata.soap.createWebServiceSuccess', { name: createdPolicy.configName })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async getPolicyById(id: number, setWebServicePolicies?: React.Dispatch<any>) {
    if (setWebServicePolicies) {
      const webServicePolicy = await TestdataSoapRestService.getById(id)
      setWebServicePolicies(webServicePolicy)
    } else {
      return TestdataSoapRestService.getById(id)
    }
  }

  async deletePolicy(policy: any, t: TFunction, setWebServicePolicies?: React.Dispatch<any>) {
    try {
      await TestdataSoapRestService.deleteWebServicePolicy(policy.id)
      if (setWebServicePolicies) {
        const webServicePolicies = await TestdataSoapRestService.getAllWebServicePolicies()
        setWebServicePolicies(webServicePolicies)
      }
      return t('testdata.soap.deleteWebServiceSuccess', { name: policy.configName })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async updatePolicy(policy: any, t: TFunction, setWebServicePolicies?: React.Dispatch<any>) {
    try {
      const editedPolicy = await TestdataSoapRestService.updateWebServicePolicy(policy)
      if (setWebServicePolicies) {
        const policies = await TestdataSoapRestService.getAllWebServicePolicies()
        setWebServicePolicies(policies)
      }
      return t('testdata.soap.editWebServiceSuccess', { name: editedPolicy.configName })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async copyPolicy(row: any, t: TFunction, setWebServicePolicies?: React.Dispatch<any>) {
    try {
      const editedPolicy = await TestdataSoapRestService.copyWebServicePolicy(row)
      if (setWebServicePolicies) {
        const policies = await TestdataSoapRestService.getAllWebServicePolicies()
        setWebServicePolicies(policies)
      }
      return t('testdata.soap.copyWebServiceSuccess', { name: editedPolicy.configName })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async generateCSV(config: any) {
    try {
      const generatedCsv = await TestdataSoapRestService.generateCsv(config)
      saveAs(generatedCsv, 'generated.csv')
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async addTokenizerConfig(config: any, t: TFunction, setWebServicePolicies?: React.Dispatch<any>) {
    try {
      const addedTokConfig = await TestdataSoapRestService.addTokenizerConfig(config)
      if (setWebServicePolicies) {
        const tokenizerConfigs = await TestdataSoapRestService.getAllWebServicePolicies()
        setWebServicePolicies(tokenizerConfigs)
      }
      return t('testdata.tokenizerConfig.assignTokConfigSuccess', { configName: addedTokConfig.columnName })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async updateTokenizerConfig(config: any, t: TFunction, setWebServicePolicies?: React.Dispatch<any>) {
    try {
      const editedTokConfig = await TestdataSoapRestService.updateTokenizerConfig(config)
      if (setWebServicePolicies) {
        const tokenizerConfigs = await TestdataSoapRestService.getAllWebServicePolicies()
        setWebServicePolicies(tokenizerConfigs)
      }
      return t('testdata.tokenizerConfig.editTokConfigSuccess', { name: editedTokConfig.columnName })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async deleteTokenizerConfig(config: any, t: TFunction, setWebServicePolicies?: React.Dispatch<any>) {
    try {
      await TestdataSoapRestService.deleteTokenizerConfig(config.id)
      if (setWebServicePolicies) {
        const policies = await TestdataSoapRestService.getAllWebServicePolicies()
        setWebServicePolicies(policies)
      }
      return t('testdata.tokenizerConfig.deleteTokConfigSuccess', { name: config.columnName })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async getAllSoapApps(setWebservices?: React.Dispatch<any>) {
    if (setWebservices) {
      const webServices = await TestdataSoapRestService.getAllSoapApps()
      setWebservices(webServices)
    } else {
      return TestdataSoapRestService.getAllSoapApps()
    }
  }

  async getSoapAppById(id: number, setSoapApps?: React.Dispatch<any>) {
    if (setSoapApps) {
      const soapApp = await TestdataSoapRestService.getSoapAppById(id)
      setSoapApps(soapApp)
    } else {
      return TestdataSoapRestService.getSoapAppById(id)
    }
  }

  async startWebService(webService: any, t: TFunction, setWebServices?: React.Dispatch<any>) {
    try {
      await TestdataSoapRestService.startWebServiceById(webService.id)
      if (setWebServices) {
        const webServices = await TestdataSoapRestService.getAllSoapApps()
        setWebServices(webServices)
      }
      return t('testdata.soap.startWebServiceSuccess', { name: webService.name })
    } catch (error) {
      return Promise.reject(error)
    }
  }

  async stopWebService(webService: any, t: TFunction, setWebServices?: React.Dispatch<any>) {
    try {
      await TestdataSoapRestService.stopWebServiceById(webService.id)
      if (setWebServices) {
        const webServices = await TestdataSoapRestService.getAllSoapApps()
        setWebServices(webServices)
      }
      return t('testdata.soap.stopWebServiceSuccess', { name: webService.name })
    } catch (error) {
      return Promise.reject(error)
    }
  }
}

export default new TestdataSoapService() as TestdataSoapService
